import {NewsDetail} from "../modules/blocks";

export const NewsPage = () => {
    return (
        <NewsDetail />
    )
}
